import { ButtonsModalSmallCentered, ModalSmallCenteredProps, ModalSmallCentered } from '../../Modal'
import ReactDOM from 'react-dom'

interface ModalSmallFilledProps extends ModalSmallCenteredProps {
    translations: {
        title: string
        subtitle: string
        buttonAccept: string
        buttonCancel?: string
    }
    onAccept: () => void
    loading?: boolean
    disabled?: boolean
    children?: React.ReactNode
}

const ModalSmallFilled: React.FC<ModalSmallFilledProps> = ({ translations, onAccept, loading, disabled, children, ...rest }) => {
    return (
        <ModalSmallCentered {...rest}>
            <h2>{translations.title}</h2>
            <span>{translations.subtitle}</span>
            {children}
            <ButtonsModalSmallCentered setOpened={rest.setOpened} disabled={disabled} onCancel={() => { rest?.onCancel?.(); rest.setOpened(null) }} confirmText={translations.buttonAccept} cancelText={translations.buttonCancel} onAccept={onAccept} loading={loading}/>
        </ModalSmallCentered>
    )
}

interface ModalSmallFilledOutsideProps extends ModalSmallFilledProps {}

export const ModalSmallFilledOutside: React.FC<ModalSmallFilledOutsideProps> = ({ ...rest}) => {
    return (
        ReactDOM.createPortal(<ModalSmallFilled  {...rest}  />, document.body)
    )
}


export default ModalSmallFilled